export class LoanDetails {
  // public BankId: string;
  public BankName: string;
  public City: string;
  public OtherBankName: string;
  public BankBranch: string;
  public IfscCode: string;

  public BankRepresentativeName: string;
  public BankRepresentativeID: string;
  public BContactPersonDesg: string;
  public BContactPersonPhoneNumber: string;
  public BContactPersonEmail: string;

  public SanctionedDate: Date;
  public LoanAmount: string;
  public NoofInstallments: number;
  public RateofInterest: string;
  public AmountPerInstallment: number;
  public CommencementDate: Date;
  public EMIEnddate: Date;
  // public BankCity: string;
  public SanctionLetter: File;
  public SanctionLetterName: string;
  public SanctionLetterPath: string;

  public Witness1Name: string;
  public Witness1Address: string;
  public Witness2Name: string;
  public Witness2Address: string;

  public DocumentStatus: number;
  public Remarks: string;
  public AccountNumber: string;
  public TripartitePath: string;
  public BankId: number;
  public DisbursementDate :Date;
  constructor(public State: string = '', public RepaymentTenure: number = 0) {}
}
